<template>
  <v-flex>
    <v-expansion-panel v-model="selected_service" id="expansion-panel">
      <v-expansion-panel-content
        v-for="(service, index) in activeServices"
        :key="service.id"
        :data-id="service.service_id"
        :ref="'service-'+index"
        :class="{ selected: last_selected == index }"
        :disabled="!service.available"
      >
        <template v-slot:header>
          <v-flex
            xl2
            md2
            sm2
            xs2
            p-2
            class="symbol text-center headline font-weight-bold"
            v-if="service.symbol && service.available"
            v-html="service.symbol"
          ></v-flex>
          <v-flex
            xl2
            md2
            sm2
            xs2
            p-2
            class="symbol text-center headline font-weight-bold"
            v-if="service.symbol && !service.available"
          >
          <v-icon color="red">sync_disabled</v-icon>
          </v-flex>
          <v-flex  xl10 md10 sm10 xs10 v-html="$t(service.name)" class="body-2"></v-flex>
        </template>
        <v-card v-if="service.description != 0" class="subheading">
          <v-card-text v-html="$t(service.description)"></v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-flex>
</template>

<script>
export default {
  name: "rServicesList",
  props: {
    globals: null,
    services: null
  },
  data: function() {
    return {
      selected_service: null,
      last_selected: null
    };
  },
  computed: {
    activeServices: function(){
      return this.services.filter((service) => {
        return (service.displaytype != 'Tylko strona ze statystykami');
      });
    }
  },
  watch: {
    selected_service: function(val) {
      if (val != null && this.last_selected != val) {
        this.last_selected = val;
        this.$emit(
          "serviceChanged",
          [this.$refs[`service-${val}`][0].$attrs["data-id"], val]
        );
      }
    }
  }
};
</script>

<style scoped>
#expansion-panel /deep/ .v-expansion-panel__header {
  font-weight: bold;
}

#expansion-panel /deep/ .selected .symbol {
  background: var(--v-primary-base) !important;
  color: white;
}

#expansion-panel /deep/ .symbol {
  padding: 0;
  margin: 0;
  min-width: 100px;
  border: 1px solid gray;
}
</style>
